import type {ReactElement} from 'react';
import React, {useRef} from 'react';
import {StylesInputPanel} from '@Panels/styles-input-panel/styles-input-panel';
import type {StylesInputLeftDrawerProps} from './styles-input-left-drawer.types';
import styles from './styles-input-left-drawer.module.scss';
import ClickableDiv from "@Components/clickable-div/clickable-div";
import {noop} from "@Utils/general.util";


export function StylesInputLeftDrawer({isOpen, drawerClassName = '', ...panelProps}: StylesInputLeftDrawerProps): ReactElement<any> {
  const containerRef = useRef<HTMLDivElement>(null);
  const onDrawerAnimationEnd = (): void => {
    if (!containerRef.current) {
      return;
    }

    if (!isOpen) {
      containerRef.current.classList.add('_hidden');
    }
  };

  const fixedDrawerClasses = 'bg-neutral-0 border-s-standard _no-border-top _no-border-left _no-border-bottom shadow-static-elevation-3';

  return (
    <>
      <div
        ref={containerRef}
        className={`${styles.drawerContainer} ${isOpen ? styles.in: ''} ${fixedDrawerClasses} ${drawerClassName}`}
      >
        {isOpen ? <StylesInputPanel {...panelProps} /> : null}
      </div>
      {isOpen ? <ClickableDiv className={styles.overlay} onClick={panelProps.onClose ?? noop}/> : null}
    </>
  );
}
